// import { Link as RouterLink } from 'react-router-dom';
// @mui
import { Tooltip, Stack, Typography, Box } from '@mui/material';
// auth
import { useAuthContext } from '../../auth/useAuthContext';
// routes

// layouts
import LoginLayout from '../../layouts/login';
//
import AuthLoginForm from './AuthLoginForm';
// import AuthWithSocial from './AuthWithSocial';

// ----------------------------------------------------------------------

export default function Login() {
  const { method } = useAuthContext();

  return (
    <LoginLayout title='' illustration='/logo/logo_full.png'>
      <Stack spacing={2} sx={{ mb: 5, position: 'relative', justifyContent:'center' }}>
        <Typography variant="h4">Sign In</Typography>

        {/* <br /> */}
      

        <Tooltip title={method} placement="left">
          <Box
            component="img"
            alt={method}
            src="/logo/ab_logo_icon.svg"
            sx={{ width: 40, height: 40, position: 'absolute', right: 0, }}
          />
        </Tooltip>
      </Stack>

      <AuthLoginForm />

      {/* <AuthWithSocial /> */}
    </LoginLayout>
  );
}
